import { useState } from 'react';
import { useInterval } from 'usehooks-ts';
import { estimateProgress } from './progressEstimates';

export default function useEstimatedProgress(durationMs: number, enabled: boolean) {
  const [startedAt] = useState(() => Date.now());
  const [elapsedMs, setElapsedMs] = useState(0);
  useInterval(() => setElapsedMs(Date.now() - startedAt), enabled ? 250 : null);
  return estimateProgress(elapsedMs, durationMs);
}
